import { ClassicResolver } from './ClassicResolver.js';
/**
 * Tecnicamente equivalente ad un {@link ClassicResolver}, si sostituisce ad un valore iniziale in un oggetto passato al costruttore
 * @example
 * Dato il seguente codice
 * ```js
 *  var test = {
 *      campo: []
 * };
 *
 * var myqueue = new ClassicQueue(test, "campo");
 * ```
 * Ora *test.campo* conterrà *myqueue* inizializzato con il valore originale di test.campo
 */
export class ClassicQueue extends ClassicResolver {
    /**
     *
     * @param obj Oggetto contenente il velore iniziale della coda al campo **param**. Questo campo sarà sovrascritto dalla coda stessa
     * @param param Stringa con il campo di **obj** da usare per inizializzare la coda
     * @param forkResolve Se true i processi eseguiti dalla coda saranno forkati in task dedicati (vedi {@link forkProcess})
     */
    constructor(obj, param, forkResolve = false) {
        super(obj[param] ? obj[param] : [], forkResolve);
        obj[param] = this;
    }
}
